"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
const Widget_1 = require("./Widget");
class View extends Widget_1.Widget {
    render() {
        const _super = Object.create(null, {
            render: { get: () => super.render }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.render.call(this);
            if (this.dataContext != null && this.dataContext.title != null) {
                document.title = this.dataContext.title + " - MMM";
            }
        });
    }
    forceTitleUpdate() {
        document.title = this.dataContext.title + " - MMM";
    }
}
exports.View = View;
//# sourceMappingURL=View.js.map